import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import axios from "axios";
import ReactPaginate from "react-paginate";
import queryString from "query-string";

// Components
import Loader from "../../utils/Loader";
import SearchbarInput from "./SearchbarInput";


// CSS
import "../../../css/pagination.css";

class Searchbar extends Component {
	constructor(props) {
		super(props);

		const query = !!props.location ? queryString.parse(props.location.search) : {};
		let pg = !!query.pg ? query.pg : "";
		const q = !!query.q
			? queryString.parse(props.location.search)[
			Object.keys(queryString.parse(props.location.search))[0]
			]
			: "";
		const sort = !!query.sort ? query.sort : "";
		const dir = !!query.dir ? query.dir : "";

		if (pg < 0) pg = 0;

		this.state = {
			isLoading: false,
			errors: null,
			data: null,
			q: !!q ? q : "",
			sort: sort,
			sort_order: dir,
			pageCount: 8,
			page: pg ? parseInt(pg, 0) : 0,
			pushState: !!this.props.pushState ? this.props.pushState : false
		};
	}

	// ===================================
	//  LIFE CYCLE
	// ===================================
	componentDidMount() {
		if (!!this.props.onRef) this.props.onRef(this);
		this.search();
	}

	componentWillUnmount() {
		if (!!this.props.onRef) this.props.onRef(undefined);
	}

	componentWillReceiveProps(nextProps) {
		const prevQuery = !!this.props.location
			? queryString.parse(this.props.location.search)
			: {};
		const nextQuery = !!nextProps.location ? queryString.parse(nextProps.location.search) : {};

		const prevSort = !!prevQuery.sort ? prevQuery.sort : "";
		const nextSort = !!nextQuery.sort ? nextQuery.sort : "";

		const prevDir = !!prevQuery.dir ? prevQuery.dir : "";
		const nextDir = !!nextQuery.dir ? nextQuery.dir : "";

		const prevPg = !!prevQuery.pg ? prevQuery.pg : "";
		let nextPg = !!nextQuery.pg ? nextQuery.pg : "";

		const prevQ = !!prevQuery.q ? prevQuery.q : "";
		const nextQ = !!nextQuery.q ? nextQuery.q : "";

		if (nextPg < 0) nextPg = 0;

		if (prevQ !== nextQ || prevPg !== nextPg || prevSort !== nextSort || prevDir !== nextDir) {
			this.setState(
				{
					q: !!nextQ ? nextQ : "",
					page: !!nextPg ? parseInt(nextPg, 0) : 0,
					sort: !!nextSort ? nextSort : "",
					sort_order: !!nextDir ? nextDir : ""
				},
				() => this.search()
			);
		}
	}

	// ===================================
	//  SEARCH
	// ===================================
	search = () => {
		this.setState({ isLoading: true });

		const apiEndpoint = this.props.searchEndpoint;
		const params = {
			q: this.state.q,
			pg: this.state.page + 1,
			order_by: this.state.sort,
			sort_order: this.state.sort_order,
			access_type: this.props.userType === "admin" ? "admin" : "user",
			max: !!this.props.max ? this.props.max : null,
			language: process.env.REACT_APP_LANGUAGE
		};

		if (!!this.props.params) {
			Object.keys(this.props.params).forEach(key => {
				params[key] = this.props.params[key];
			});
		}

		const userToken = this.props.user ? this.props.user.token : null;

		const AUTH_HEADER = { Authorization: process.env.REACT_APP_SITE_KEY };
		// if (this.props.userType === "admin") {
		AUTH_HEADER.Authorization += ":Bearer " + userToken;
		// }

		return axios
			.get(process.env.REACT_APP_API_URL + apiEndpoint, {
				headers: AUTH_HEADER,
				params: params
			})
			.then(response => {
				if (
					response.status !== 200 ||
					(response.data.status && response.data.status !== 200)
				) {
					this.setState({ isLoading: false, error: response.data.message });
				} else {
					let responseData =
						this.props.userType === "admin"
							? { ...response.data }
							: { ...response.data.items };

					this.setState({
						isLoading: false,
						data: { items: responseData, ...response.data }
					});
				}
			})
			.catch(err => {
				this.setState({
					isLoading: false,
					error: err.response.data.errors
						? err.response.data.errors
						: err.response.data.message
				});
			});
	};

	// ===================================================================================
	//  HANDLE CHANGES
	// ===================================================================================
	handlePaginationChange(data) {
		// The page number selected
		const selected = data.selected;

		// Get any other query objects
		let queryObj = {};
		const query = !!this.props.location ? queryString.parse(this.props.location.search) : {};
		const q = !!query.q ? query.q : "";
		if (!!q) queryObj.q = q;

		const sort = !!query.sort ? query.sort : "";
		if (!!sort) queryObj.sort = sort;

		const dir = !!query.dir ? query.dir : "";
		if (!!dir) queryObj.dir = dir;

		queryObj.pg = selected;

		// Make a valid url string (pg=2&q=cow, etc)
		const qs = queryString.stringify(queryObj);

		// Push to history.  componentWillReceiveProps() will take care of triggering the search
		this.props.history.push("?" + qs);
	}

	handleKeyPress = e => {
		if (e.key === "Enter") {
			const query = !!this.props.location
				? queryString.parse(this.props.location.search)
				: {};
			const sort = !!query.sort ? query.sort : "";
			const dir = !!query.dir ? query.dir : "";

			let queryObj = {};
			if (!!sort) queryObj.sort = sort;
			if (!!dir) queryObj.dir = dir;

			// console.log(this.state.q)

			queryObj.q = this.state.q;

			queryObj = queryString.stringify(queryObj);

			this.props.history.push("?" + queryObj);
		}
	};

	handleInputChange = e => {
		this.setState({
			q: e.target.value
		});
	};

	renderTable() {
		// Component passed in that displays search results
		const startPosition = this.state.data
			? this.state.data.items_per_page * (this.state.data.current_page - 1)
			: 0;
		const SearchTable = this.props.component;

		// Send items to search listing with the index specified by the props, or simply the default 'items'
		const itemPropName = !!this.props.itemsIndex ? this.props.itemsIndex : "items";
		let itemProp = {};
		itemProp[itemPropName] = this.state.data.items;

		return (
			<div className="search-listing">
				<SearchTable
					{...itemProp}
					startPosition={startPosition}
					basePath={this.props.location.pathname}
					{...this.props}
					reviewId={this.props.reviewId}
				/>
			</div>
		);
	}

	render() {
		return (
			<div>
				<SearchbarInput
					placeholder={this.props.placeholder}
					handleKeyPress={this.handleKeyPress}
					handleInputChange={this.handleInputChange}
					disabled={this.props.disabled}
					search={this.search}
					q={this.state.q}
				/>

				{this.props.content && <div>{this.props.content}</div>}

				{this.state.isLoading ? (
					<Loader />
				) : this.state.errors ? (
					<div className="error">
						{Object.keys(this.state.error).map(key => (
							<span key={key}>{this.state.error[key]}</span>
						))}
					</div>
				) : (
							this.state.data !== null &&
							(this.state.data.total_pages > 1 && !this.props.disabled ? (
								<div>
									<ReactPaginate
										previousLabel={""}
										previousLinkClassName={"icon-previous"}
										nextLabel={""}
										nextLinkClassName={"icon-next"}
										breakLabel={"..."}
										breakClassName={"break-me"}
										pageCount={this.state.data.total_pages}
										disableInitialCallback={true}
										initialPage={this.state.page}
										marginPagesDisplayed={2}
										pageRangeDisplayed={4}
										onPageChange={this.handlePaginationChange.bind(this)}
										containerClassName={"pagination"}
										subContainerClassName={"pages pagination"}
										activeClassName={"active"}
									/>
									{this.renderTable()}
								</div>
							) : (
									this.renderTable()
								))
						)}
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		user: state.user[ownProps.userType]
	};
};

export default withRouter(connect(mapStateToProps)(Searchbar));



// WEBPACK FOOTER //
// ./src/components/utils/searchbar/Searchbar.js